import { useEffect, useState } from "react";
import { CheckTest, PopupResult, QuestionCard } from "../styles/TestCard.Main";
import { MTButton } from "../../../components/button/MTButton";
import RiskPlanList from "./Risk_Plan_List";
import { ICON_INFO } from "../../../utils/useIcons";

const ViewFireCase = ({ formRisk, setFormRisk, setMenu, setRiskData }) => {
  const [openResult, setOpenResult] = useState(false);

  //---------- ข้อหนึ่ง ----------//
  const onChangeFireLevelPassAway = (e) => {
    let value = e.target.value;
    if (value === "high") {
      setFormRisk({
        ...formRisk,
        fire_level_pass_away_high: true,
        fire_level_pass_away_medium: false,
        fire_level_pass_away_low: false,
      });
    } else if (value === "medium") {
      setFormRisk({
        ...formRisk,
        fire_level_pass_away_high: false,
        fire_level_pass_away_medium: true,
        fire_level_pass_away_low: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        fire_level_pass_away_high: false,
        fire_level_pass_away_medium: false,
        fire_level_pass_away_low: true,
      });
    }
  };

  //---------- ข้อสอง ----------//
  const onChangeFirePassAwayYesterday = (e) => {
    let value = e.target.value;
    if (value === "high") {
      setFormRisk({
        ...formRisk,
        fire_pass_away_yesterday_high: true,
        fire_pass_away_yesterday_medium: false,
        fire_pass_away_yesterday_low: false,
      });
    } else if (value === "medium") {
      setFormRisk({
        ...formRisk,
        fire_pass_away_yesterday_high: false,
        fire_pass_away_yesterday_medium: true,
        fire_pass_away_yesterday_low: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        fire_pass_away_yesterday_high: false,
        fire_pass_away_yesterday_medium: false,
        fire_pass_away_yesterday_low: true,
      });
    }
  };

  //---------- ข้อสาม ----------//
  const onChangeFireManageRisk = (e) => {
    let value = e.target.value;
    if (value === "avoid") {
      setFormRisk({
        ...formRisk,
        fire_manage_risk_avoidance: true,
        fire_manage_risk_control: false,
        fire_manage_risk_accept: false,
        fire_manage_risk_transfer: false,
      });
    } else if (value === "control") {
      setFormRisk({
        ...formRisk,
        fire_manage_risk_avoidance: false,
        fire_manage_risk_control: true,
        fire_manage_risk_accept: false,
        fire_manage_risk_transfer: false,
      });
    } else if (value === "accept") {
      setFormRisk({
        ...formRisk,
        fire_manage_risk_avoidance: false,
        fire_manage_risk_control: false,
        fire_manage_risk_accept: true,
        fire_manage_risk_transfer: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        fire_manage_risk_avoidance: false,
        fire_manage_risk_control: false,
        fire_manage_risk_accept: false,
        fire_manage_risk_transfer: true,
      });
    }
  };

  //---------------------------//

  const getSum = () => {
    let sumScore = 0;
    if (formRisk?.fire_pass_away_yesterday_high) {
      sumScore += 1;
    }
    if (formRisk?.fire_pass_away_yesterday_medium) {
      sumScore += 1;
    }
    if (formRisk?.fire_manage_risk_avoidance) {
      sumScore += 1;
    }
    if (formRisk?.fire_manage_risk_control) {
      sumScore += 1;
    }
    if (formRisk?.fire_manage_risk_accept) {
      sumScore += 1;
    }
    if (formRisk?.fire_manage_risk_transfer) {
      sumScore += 1.5;
    }

    return sumScore;
  };

  useEffect(() => {
    setFormRisk({
      ...formRisk,
      fire_sum_score: getSum(),
    });
    setRiskData({
      ...formRisk,
      fire_sum_score: getSum(),
    });
  }, [getSum()]);

  useEffect(() => {
    if (openResult) {
      document?.getElementById("result_fire")?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [openResult]);

  const onClickSubmit = () => {
    setOpenResult(!openResult);
  };

  // console.log("formRisk : ", formRisk);
  // console.log("sum : ", getSum());

  return (
    <div className="mt-[14px] px-[25px]">
      <div className=" flex flex-col justify-center items-center gap-1">
        <img src="/images/risk_fire.svg" className=" w-[50px] h-[50px]" />
        <div className=" text-center text-black font-semibold ">
          กรณีอัคคีภัย
        </div>
      </div>
      <div className=" flex flex-col gap-4 mt-[14px]">
        <QuestionCard
          name="one"
          checkedHigh={formRisk?.fire_level_pass_away_high}
          checkedMedium={formRisk?.fire_level_pass_away_medium}
          checkedLow={formRisk?.fire_level_pass_away_low}
          formRisk={formRisk}
          onChange={onChangeFireLevelPassAway}
          question="1. ท่านคิดว่าโอกาสการเกิดอัคคีภัยสินทรัพย์ของท่านอยู่ในระดับใด  "
          choice1={`สูง`}
          choice2={`กลาง`}
          choice3={`ต่ำ`}
        />
        <QuestionCard
          name="two"
          checkedHigh={formRisk?.fire_pass_away_yesterday_high}
          checkedMedium={formRisk?.fire_pass_away_yesterday_medium}
          checkedLow={formRisk?.fire_pass_away_yesterday_low}
          formRisk={formRisk}
          onChange={onChangeFirePassAwayYesterday}
          question="2. ถ้าเมื่อวานเกิดอัคคีภัยกับสินทรัพย์ของท่านมีความเสียหายสูง จะมีผลกระทบทางการเงินขอท่านในระดับใด"
          choice1={`สูง`}
          choice2={`กลาง`}
          choice3={`ต่ำ`}
        />
        <QuestionCard
          name="three"
          checkedAvoidance={formRisk?.fire_manage_risk_avoidance}
          checkedControl={formRisk?.fire_manage_risk_control}
          checkedAccept={formRisk?.fire_manage_risk_accept}
          checkedTransfer={formRisk?.fire_manage_risk_transfer}
          formRisk={formRisk}
          onChange={onChangeFireManageRisk}
          position={"verticle"}
          question={
            <div className="flex gap-1.5">
              3. ท่านมีวิธีการจัดการความเสี่ยงกรณีอัคคีภัยในปัจจุบันอย่างไร
              <a href="https://www.youtube.com/watch?v=PlqpT01BoIk">
                <ICON_INFO className={`flex-none text-gray90 w-6 h-6`} />
              </a>
            </div>
          }
          choice1={`หลีกเลี่ยงความเสี่ยง`}
          choice2={`ควบคุมความเสี่ยง`}
          choice3={`รับความเสี่ยง`}
          choice4={`โอนความเสี่ยง`}
        />
      </div>

      <div className="flex justify-center my-6">
        <MTButton
          text="แสดงผลลัพธ์"
          // loading={loading}
          onClick={onClickSubmit}
        />
      </div>

      {openResult && (
        <div className="flex flex-col">
          <div className=" text-mainblue font-semibold text-center mt-6 mb-4 ">
            ผลลัพธ์วางแผนกรณีอัคคีภัย
          </div>

          {formRisk?.fire_sum_score === 1 && (
            <PopupResult
              img="/images/good1.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`ท่านมีความสามารถในการรับ`}
              text2={`ความเสี่ยงไว้เองได้`}
            />
          )}

          {formRisk?.fire_sum_score === 1.5 && (
            <PopupResult
              img="/images/good2.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยง`}
              text2={`ได้เหมาะสมท่านมีความสามารถในการรับ`}
              text3={`ความเสี่ยงไว้เองได้`}
            />
          )}

          {formRisk?.fire_sum_score === 2 && (
            <PopupResult
              img="/images/fire_shield.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`แนะนำให้ท่านโอนความเสี่ยง`}
              text2={`ด้วยการทำประกันอุบัติเหตุ`}
            />
          )}

          {formRisk?.fire_sum_score === 2.5 && (
            <PopupResult
              img="/images/good_fire_shield.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยง`}
              text2={`ได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยง`}
              text3={`ด้วยการทำประกันทรัพย์สินและอัคคีภัย`}
            />
          )}

          <div className=" mt-6">
            <div className=" text-black text-center font-medium">
              แบบทดสอบวิธีจัดการความเสี่ยงของท่าน
            </div>
            <RiskPlanList formRisk={formRisk} setMenu={setMenu} />
          </div>
        </div>
      )}
      <div className="mt-6" id="result_fire"></div>
    </div>
  );
};
export default ViewFireCase;
